import env from '../config';

const emailOptInSection = () => {
  // If the email section is not on the page then don't set up the handlers.
  if (!document.querySelector('#email-opt-in')) return;
  const form = document.getElementById('email-sign-up-form');
  const successMessage = document.getElementById('email-sign-up-success');
  const input = form.querySelector('[name=email]');
  const inputWrap = form.querySelector('fieldset');

  const error = () => {
    input.classList.add('input-invalid');
  };

  const success = () => {
    inputWrap.style.display = 'none';
    successMessage.style.display = 'block';
    input.classList.remove('input-invalid');
    setTimeout(() => {
      successMessage.style.display = 'none';
      inputWrap.style.display = 'flex';
    }, '8000');
  };

  const submitEmailFunction = (email) => {
    const options = {
      body: JSON.stringify({
        campaign_source: 'general_email_signup',
        customer_id: email,
        email,
        inbound_source: 'dotcom',
        unsubscribed: 'false',
      }),
      headers: {
        'X-API-KEY': env.BLUESHIFT_KEY,
        accept: 'application/json',
        'content-type': 'application/json',
      },
      method: 'POST',
    };

    fetch(env.BLUESHIFT_URL, options).then((response) => {
      if (!response.ok) {
        // TODO(Sentry): Add monitoring
        console.error(`HTTP error! Status: ${response.status}`);
        error();
      } else {
        success();
      }
    });
  };

  form.addEventListener('submit', (evt) => {
    const formData = new FormData(form);
    const email = formData.get('email');
    evt.preventDefault();
    submitEmailFunction(email);
    evt.stopImmediatePropagation();
  });
};

export default emailOptInSection;
